import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {useCommonContext} from "../../../contexts/CommonContext";
import NewShopOrderStore from "./NewShopOrderStore";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./NewShopOrderButton.style";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import Button from "../../../ui_components/Button/Button";
import Steppers from '../../../ui_components/Stepper/Steppers';
import StepperOption from '../../../ui_components/Stepper/StepperOption';
import AdditionalPrices from './AdditionalPrice/AdditionalPrices/AdditionalPrices';
import ShopOrderResume from './Resume/ShopOrderResume';
import NewShopOrderButtonProperties from './NewShopOrderButtonProperties';
import SidePanel from '../../../ui_components/SidePanel/SidePanel';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ShopProductSelect from './ShopProductSelect/ShopProductSelect';
import ClientSelect from './ClientSelect/ClientSelect';
import Payment from './Payment/Payment';


const NewShopOrderButton: React.FC<NewShopOrderButtonProperties> = ({
                                                                                                onClick = () => {
                                                                                                },
                                                                                                showIcon = true,
                                                                                                onSave = () => {
                                                                                                },
                                                                                                showText = true,
                                                                                                disabled,
                                                                                                className = '',
                                                                                                rounded = false,
                                                                                                size = ButtonSize.DEFAULT,
                                                                                                type = ButtonType.DEFAULT
                                                                                            }) => {
    const classes = useStyles();
    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const store = new NewShopOrderStore(commonContext);

    const handleOnclick = async () => {
        onClick();
        await store.openModal();
    }

    const onCloseModal = () => {
        store.closeModal();
    }
    const isClientStepCompleted = (): boolean => {
        return store.selectedClient != null;
    }

    const isSelectShopProductStepCompleted = (): boolean => {
        return store.selectedProducts.length > 0;
    }

    const text = showText ? i18n.translate("NEW_SHOP_ORDER") : "";
    const tooltip = !showText ? i18n.translate("NEW_SHOP_ORDER") : "";
    const btnIcon = showIcon ? <ShoppingCartIcon/> : React.Fragment;

    let index = 0;
    let steps: StepperOption[] = [];
    steps.push(new StepperOption(0, 'Sleccione productos', isSelectShopProductStepCompleted, <ShopProductSelect
        store={store}/>));
    steps.push(new StepperOption(1, i18n.translate("SELECT_CONTACT_PLACEHOLDER"), isClientStepCompleted, <ClientSelect
            store={store}/>));
    steps.push(new StepperOption(2, "Precios y tarifas", () => true, <AdditionalPrices
            store={store}/>, () => {}));
    steps.push(new StepperOption(index++, i18n.translate("PAYMENT"), () => {
        return true;
    }, <Payment
        store={store}/>));
    steps.push(new StepperOption(3, i18n.translate("RESUME"), () => {
            return false;
        }, <ShopOrderResume store={store}/>));

    const handleFinish = () => {
        store.createShopOrder();
        if (onSave) {
            onSave();
        }
    };

    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                className={className}
                onClick={handleOnclick}
                tooltip={tooltip}
                disabled={disabled}
                size={size}
                type={type}
                text={text}
                icon={btnIcon}
            />
        }
        return <Button
            className={className}
            onClick={handleOnclick}
            tooltip={tooltip}
            disabled={disabled}
            size={size}
            type={type}
            text={text}
            startIcon={btnIcon}
        />
    }

    return <Observer>
        {() => (
            <>
                <SidePanel title={i18n.translate("NEW_SHOP_ORDER")} onClose={onCloseModal}
                           open={store.isModalOpen} className={classes.modal_container}>
                    {!store.response &&
                        <Steppers 
                            activeStep={store.activeStep}
                            onActiveStepChange={(value) => {
                                store.activeStep = value;
                            }}
                            steps={steps} containerClassName={classes.stepper_container}
                            handleFinish={handleFinish} finishButtonLoading={store.finishButtonLoading}/>}    
                </SidePanel>
                <Btn/>
            </>
        )}
    </Observer>
}

export default NewShopOrderButton;
